import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './About.css';
import Trans from '../img/Trans.png';

function About() {
  return (
    <div className="about">
      <Helmet>
        <title>About Us | Doggy Duty WNY | Pet Waste Removal in Buffalo, NY</title>
        <meta
          name="description"
          content="Discover how Doggy Duty WNY keeps Buffalo yards clean and safe with our professional pet waste removal services."
        />
        <meta
          name="keywords"
          content="dog waste removal Buffalo, pet waste cleanup, lawn care for pets, eco-friendly pet waste disposal, Buffalo yard cleaning"
        />
        <meta name="author" content="Doggy Duty WNY" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="about-header text-center py-5">
        <h1>About Doggy Duty WNY</h1>
        <p className="tagline">"Keeping yards clean, one scoop at a time!"</p>
      </div>

      <section className="who-we-are py-5">
        <div className="container">
          <div className="row">
            <article className="col-md-6">
              <h2>Who We Are</h2>
              <p>
                At Doggy Duty WNY, we believe that a clean yard means a happier, healthier home for both pets and their owners. 
                We specialize in professional dog waste removal services, ensuring that your outdoor space remains fresh, sanitary, and odor-free.
              </p>
              <p>
                Our trained team follows a meticulous cleanup process, offering weekly, bi-weekly, and one-time cleanups at affordable rates. 
                Whether you’re a busy pet owner, have limited mobility, or simply prefer not to deal with the mess, we’re here to help.
              </p>
              <p>
                With a commitment to excellent customer service, we ensure that every yard we service is left spotless, providing convenience and peace of mind. 
                Say goodbye to unpleasant odors, unsightly messes, and unnecessary stress—Doggy Duty WNY has got you covered!
              </p>
            </article>
            <div className="col-md-4">
              <img
                src={Trans}
                alt="Doggy Duty WNY - Pet Waste Removal in Buffalo, NY"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="why-clean-yard py-5 bg-light">
        <div className="container text-center">
          <h2>Why a Clean Yard Matters</h2>
          <p>
            Dog waste isn’t just an eyesore—it can pose serious health risks to pets and people. Bacteria and parasites found in pet waste can 
            contaminate soil and water, leading to potential illness. Regular cleanup helps prevent the spread of harmful germs, keeps your 
            lawn lush, and creates a more enjoyable outdoor space for the whole family.
          </p>
          <p>
            Additionally, dog waste contains harmful pathogens like E. coli, salmonella, and roundworms that can be hazardous if left untreated. 
            A well-maintained yard protects children and other pets from accidental exposure to these risks. Keeping your outdoor space clean 
            isn't just about appearance—it's about safety and hygiene too.
          </p>
        </div>
      </section>

      <section className="why-choose-us py-5">
        <div className="container">
          <h2 className="text-center">Why Choose Doggy Duty WNY?</h2>
          <div className="row mt-4">
            <article className="col-md-4">
              <div className="choose-card p-4 border">
                <h3>Reliable & Professional</h3>
                <p>Our team is punctual, thorough, and dedicated to keeping your yard spotless. Enjoy peace of mind knowing your space is clean and fresh.</p>
              </div>
            </article>
            <article className="col-md-4">
              <div className="choose-card p-4 border">
                <h3>Health & Safety First</h3>
                <p>Pet waste can carry harmful bacteria. We ensure proper disposal to protect your family, pets, and the environment.</p>
              </div>
            </article>
            <article className="col-md-4">
              <div className="choose-card p-4 border">
                <h3>locally-Owned</h3>
                <p>We are a small locally-owned team committed to helping our neighbors enjoy cleaner yards We’re Buffalonians taking care of fellow Buffalonians</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="benefits-section py-5 bg-light">
        <div className="container">
          <h2 className="text-center">The Benefits of Regular Pet Waste Removal</h2>
          <p>
            Keeping up with pet waste removal is essential for maintaining a healthy yard. Here are some of the biggest benefits:
          </p>
          <ul>
            <li>Prevents the spread of disease-causing bacteria and parasites.</li>
            <li>Eliminates unpleasant odors, making outdoor spaces more enjoyable.</li>
            <li>Reduces the risk of pet waste contaminating local water supplies.</li>
            <li>Protects your lawn from damage caused by acidic dog waste.</li>
            <li>Creates a cleaner, safer space for pets and children to play.</li>
          </ul>
        </div>
      </section>

      <section className="cta-section text-center py-5">
        <p className="cta-text">
          Check out our <Link to="/services" className="cta-link">services</Link> or <Link to="/contact" className="cta-link">contact us</Link> today! 
          Enjoy a poop-free yard all year long with Doggy Duty WNY.
        </p>
      </section>
    </div>
  );
}

export default About;
